// extracted by mini-css-extract-plugin
export default {"detailList":"detailList_detailList__kX5c+"};